/**
*
*   Featured Products
*       - The featured products collection on the home page
*
**/
import Config from '@/config';
import Button from '@/components/button';
import Image from '@/components/image';
import { Link } from '@/components/link';
import { useLocale, useTranslations } from 'next-intl';

//Build the Element
export default function Advertisement({ ...props }){

    //Skip advertisement
    //return false;

    //
    const locale = useLocale();

    const content = {
        //link:       '/collections/sale',
        image:      'advertisements/mothers-day-sale-2025.jpg',
        en: {
            header:     'Mothers Day Sale',
            subheader:  'Buy two get one 50% off',
            content:    'Buy two of any product, get the third 50% off, and get a free 5ml of Palmarosa when you spend over $80',
            alt:        'Buy two get one 50% off site wide',
            button:     'View Sale'
        },
        fr: {
            header: 'Soldes Fête des Mères',
            subheader: 'Achetez deux produits, obtenez-en un à 50 % de réduction',
            content: 'Achetez deux produits de n\'importe quel type, obtenez le troisième à 50 % de réduction et recevez 5 ml de Palmarosa gratuits lorsque vous dépensez plus de 80 $',
            alt: 'Achetez deux produits, obtenez-en un à 50 % de réduction sur tout le site',
            button: 'Voir les soldes'
        }
    }

    //Skip the link if there is no link available
    const Linkable = ({ href , children }) => {
        if( href ) return <Link href={ href }>{ children }</Link>
        return children;
    }

    //Return
    return (
        <section className="advertisement">
            <Linkable href={ content?.link }>
                <Image src={ content.image } width="890" height="890" alt={ content[ locale ]?.alt } />
            </Linkable>
            <div className="details">
                <h3>{ content[ locale ]?.header }</h3>
                <p className="inci">{ content[ locale ]?.subheader }</p>
                <p>{ content[ locale ]?.content }</p>
                { content?.link && (
                    <Button href={ content.link } narrow>{ content[ locale ]?.button }</Button>
                )}
            </div>
        </section>
    );

}